import { Box, Button, Typography } from '@mui/material';
import coveredFrontImage from './images/ti7/teaser-covered-front.jpg';
import profileImage from './images/ti7/teaser-profile.jpg';
import rearImage from './images/ti7/teaser-rear.jpg';
import coveredSideImage from './images/ti7/teaser-covered-side.jpg';
import { createWhatsAppUrl } from './siteConfig';

// Limit exposure to retain the teaser's edge lighting without revealing body details.
const images = [
  {
    src: coveredFrontImage,
    alt: 'Mobil misterius BYD tertutup kain hitam, tampak depan',
    width: 1122,
    height: 1402,
    brightness: 0.8,
  },
  {
    src: profileImage,
    alt: 'Siluet mobil misterius BYD dengan cahaya tipis di kontur atap',
    width: 1122,
    height: 1402,
    brightness: 0.65,
  },
  {
    src: rearImage,
    alt: 'Siluet mobil misterius BYD tampak belakang dalam bayangan',
    width: 1003,
    height: 1568,
    brightness: 0.45,
  },
  {
    src: coveredSideImage,
    alt: 'Mobil misterius BYD tertutup kain hitam, tampak samping',
    width: 1122,
    height: 1402,
    brightness: 0.8,
  },
];

function UpcomingTi7() {
  return (
    <Box
      component='section'
      id='coming-soon'
      aria-labelledby='coming-soon-title'
      sx={{
        px: { xs: 2, md: 6 },
        py: { xs: 5, md: 7 },
        backgroundColor: '#101619',
        color: '#fff',
      }}
    >
      <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
        <Typography
          sx={{
            fontSize: '0.75rem',
            letterSpacing: 2,
            color: '#b4c1c6',
            textTransform: 'uppercase',
          }}
        >
          Coming soon
        </Typography>
        <Typography
          id='coming-soon-title'
          component='h2'
          sx={{ mt: 1, fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 700 }}
        >
          Satu siluet. Banyak tanda tanya.
        </Typography>
        <Typography sx={{ mt: 1, color: '#c5cdd1', lineHeight: 1.7 }}>
          Kejutan baru dari BYD. Rencana terungkap November 2026.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
            gap: { xs: 1.5, md: 2 },
          }}
        >
          {images.map((item) => (
            <Box
              key={item.src}
              sx={{
                position: 'relative',
                aspectRatio: '4 / 5',
                overflow: 'hidden',
                backgroundColor: '#020407',
              }}
            >
              <Box
                component='img'
                src={item.src}
                alt={item.alt}
                width={item.width}
                height={item.height}
                loading='lazy'
                sx={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  filter: `brightness(${item.brightness})`,
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'linear-gradient(180deg, transparent 30%, rgba(0,0,0,0.65) 100%)',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: 14, md: 20 },
                  left: { xs: 12, md: 18 },
                  right: 12,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '0.7rem', md: '0.8rem' },
                    letterSpacing: 1.5,
                    fontWeight: 700,
                  }}
                >
                  COMING SOON
                </Typography>
                <Typography
                  sx={{ mt: 0.6, fontSize: { xs: '0.85rem', md: '1rem' } }}
                >
                  November 2026
                </Typography>
                <Typography
                  sx={{ mt: 0.4, fontSize: '0.75rem', color: '#bec8cd' }}
                >
                  Harga coming soon
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
        <Button
          href={createWhatsAppUrl(
            'Halo Junius, saya penasaran dengan kejutan BYD yang direncanakan terungkap November 2026. Tolong kabari saat detail dan harganya tersedia.',
          )}
          target='_blank'
          rel='noopener noreferrer'
          variant='outlined'
          sx={{
            mt: 3,
            color: '#fff',
            borderColor: '#7f929b',
            textTransform: 'none',
            '&:hover': {
              borderColor: '#fff',
              backgroundColor: 'rgba(255,255,255,0.06)',
            },
          }}
        >
          Jadi yang pertama tahu
        </Button>
      </Box>
    </Box>
  );
}

export default UpcomingTi7;
